export const RESPONSE_CODES = {
  intentRecognition: {
    showInAdvancedSettings: false,
    title: 'ResponseBody',
    content: {
      intent: {
        confidence: 0.9,
        name: 'credit',
      },
      intentRanking: [
        {
          confidence: 0.9,
          name: 'credit',
        },
      ],
    },
  },
  entityExtract: {
    showInAdvancedSettings: false,
    title: 'ResponseBody',
    content: {
      nameOfEntity: 'extractedValueForEntity',
    },
  },
  generativeQuestionAnswering: {
    showInAdvancedSettings: false,
    title: 'ResponseBody',
    content: {
      result: [
        {
          answer: 'answer',
          standaloneQuestion: 'question',
          docs: [
            {
              source: 'file.txt',
              score: 0.20298055250630587,
              content: 'content',
            },
          ],
          logs: {
            openaiDuration: 2.017857313156128,
            fullDuration: 2.024966239929199,
          },
          cacheHit: {
            question: 'cached question',
            score: 1,
          },
        },
      ],
    },
  },
  aiAgent: {
    showInAdvancedSettings: true,
    title: 'ErrorResponseBody',
    content: {
      error: {
        code: 'code',
        message: 'message',
        details: null,
        data: null,
        validationErrors: null,
      },
    },
  },
  askLlm: {
    showInAdvancedSettings: false,
    title: 'ResponseBody',
    content: {
      results: [
        {
          choices: [
            {
              message: {
                role: 'assistant',
                content: 'Result is 5.33',
                reasoning_content: 'Calculated 16÷3',
              },
              finish_reason: 'stop',
            },
          ],
          usage: {
            prompt_tokens: 95,
            completion_tokens: 48,
            reasoning_tokens: 156,
            total_tokens: 143,
          },
        },
      ],
    },
  },
  ragAgent: {
    showInAdvancedSettings: false,
    title: 'ResponseBody',
    content: {
      answer: 'answer',
      standalone_question: 'question',
      docs: [
        {
          source: 'file.pdf',
          score: 0.6712,
          content: 'content',
        },
      ],
      cache: null,
    },
  },
};
